import { TeamReport } from 'presentation/app/modules/Reports/pages/professionals/team-report';
import React from 'react';

export const MakeTeamReport: React.FC = () => {
  return <TeamReport />;
};
